import { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import React from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { corporateColor, toqueColor, white } from '../../../theme/colors'
import { DOBRA } from '../../../theme/fonts'

interface Props {
  amount: number
  title: string
  icon: IconDefinition
  onPress: () => void
}

export const MenuItem = ({ amount, title, icon, onPress }: Props) => {
  return (
    <TouchableOpacity style={{ flexDirection: 'row' }} onPress={onPress}>
      <View style={styles.iconContainer}>
        <FontAwesomeIcon
          icon={icon}
          size={20}
          color={corporateColor}
          style={{ marginTop: 10, marginBottom: 10 }}
        />
      </View>
      <View style={styles.titleContainer}>
        <Text style={styles.title}>{title}</Text>
      </View>
      <View style={styles.amountContainer}>
        <Text style={styles.amount}>{amount}</Text>
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  iconContainer: {
    padding: 10,
    paddingRight: 30,
  },

  titleContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },

  title: {
    color: corporateColor,
    fontSize: 19,
    fontWeight: 'bold',
  },

  amountContainer: {
    justifyContent: 'center',
    marginRight: 20,
    borderRadius: 8,
  },

  amount: {
    fontFamily: DOBRA,
    fontSize: 16,
    color: white,
    padding: 12,
    paddingTop: 5,
    paddingBottom: 5,
    backgroundColor: toqueColor,
    fontWeight: 'bold',
  },
})
